/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddAnonymizationExclusionsRequestDto } from '../models/AddAnonymizationExclusionsRequestDto';
import type { AnonymizationExclusionDto } from '../models/AnonymizationExclusionDto';
import type { DataAnonymizationLookupRequestDto } from '../models/DataAnonymizationLookupRequestDto';
import type { DataAnonymizationLookupResponseDto } from '../models/DataAnonymizationLookupResponseDto';
import type { DataAnonymizationRequestDto } from '../models/DataAnonymizationRequestDto';
import type { DataAnonymizationResultDto } from '../models/DataAnonymizationResultDto';
import type { DataAnonymizationStatusDto } from '../models/DataAnonymizationStatusDto';
import type { ElementClassificationResponseDto } from '../models/ElementClassificationResponseDto';
import type { PiiKind } from '../models/PiiKind';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DataAnonymizationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Returns whether the tool is enabled in this environment and the database it would target.
     * @returns DataAnonymizationStatusDto OK
     * @throws ApiError
     */
    public getApiDataAnonymizationStatus(): CancelablePromise<DataAnonymizationStatusDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DataAnonymization/Status',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Who-is-who lookup: computes the fake equivalents of a real value (name, email, phone, …)
     * so admins with access to the original data can find the matching record in an anonymized
     * database. Nothing is stored; the mapping is not reversible from the fakes alone.
     * @param requestBody
     * @returns DataAnonymizationLookupResponseDto OK
     * @throws ApiError
     */
    public postApiDataAnonymizationLookup(
        requestBody?: DataAnonymizationLookupRequestDto,
    ): CancelablePromise<DataAnonymizationLookupResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DataAnonymization/Lookup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Classifies every form element by the kind of PII its answers contain, for admin review
     * before running. Overrides from the request are applied so the review reflects them.
     * @param requestBody
     * @returns ElementClassificationResponseDto OK
     * @throws ApiError
     */
    public postApiDataAnonymizationClassifyElements(
        requestBody?: Record<string, PiiKind>,
    ): CancelablePromise<ElementClassificationResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DataAnonymization/ClassifyElements',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Dry run: per-table counts and sample before/after pairs. Makes no changes.
     * @param requestBody
     * @returns DataAnonymizationResultDto OK
     * @throws ApiError
     */
    public postApiDataAnonymizationPreview(
        requestBody?: DataAnonymizationRequestDto,
    ): CancelablePromise<DataAnonymizationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DataAnonymization/Preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Executes one batch of anonymization and returns a continuation cursor. The client loops
     * until NextCursor is null. Requires ConfirmDatabaseName to exactly match the current
     * database. Each batch commits independently, so interrupting between batches is safe and
     * re-sending a cursor is harmless (transforms are deterministic).
     * @param requestBody
     * @returns DataAnonymizationResultDto OK
     * @throws ApiError
     */
    public postApiDataAnonymizationExecute(
        requestBody?: DataAnonymizationRequestDto,
    ): CancelablePromise<DataAnonymizationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DataAnonymization/Execute',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Lists all excluded housing application GUIDs.
     * @returns AnonymizationExclusionDto OK
     * @throws ApiError
     */
    public getApiDataAnonymizationExclusions(): CancelablePromise<Array<AnonymizationExclusionDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DataAnonymization/Exclusions',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Adds one or more housing application GUIDs to the exclusion list.
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public postApiDataAnonymizationExclusions(
        requestBody?: AddAnonymizationExclusionsRequestDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DataAnonymization/Exclusions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Removes an exclusion by its housing application GUID.
     * @param applicationGuid
     * @returns any OK
     * @throws ApiError
     */
    public deleteApiDataAnonymizationExclusions(
        applicationGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/DataAnonymization/Exclusions/{applicationGuid}',
            path: {
                'applicationGuid': applicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Clears all anonymization tracking data (processed records and name mappings).
     * Use before a fresh full run after a complete data re-import.
     * @returns any OK
     * @throws ApiError
     */
    public postApiDataAnonymizationResetTracking(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DataAnonymization/ResetTracking',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
